module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1282.c3d40220.png";